import store from '../redux/store';
import { setSearchTerm } from '../redux/actions/searchActions';

export const prepareSearchTerms = (queryTerms) => {
    const terms = [];
    if (queryTerms.search) {
        const searchTempArray = queryTerms.search.split(','); // split the ?search= terms into an array
        searchTempArray.map((item) => {
            store.dispatch(setSearchTerm(item));
            terms.push(item);
        });
    } else if (queryTerms.term || queryTerms.terms) {
        let searchTempArray = [];
        if (queryTerms.term) {
            const { term } = queryTerms;
            if (typeof term === 'string') {
                searchTempArray = term.split(',');
            } else {
                searchTempArray = term;
            }
        } else {
            const { terms } = queryTerms;
            if (typeof terms === 'string') {
                searchTempArray = terms.split(',');
            } else {
                searchTempArray = terms;
            }
        }
        searchTempArray.map((item) => {
            store.dispatch(setSearchTerm(item));
            terms.push(item);
        });
    } else if (queryTerms.searchTerms && queryTerms.searchTerms.length > 0) {
        if (typeof queryTerms.searchTerms === 'string') {
            const item = queryTerms.searchTerms.trim();
            store.dispatch(setSearchTerm(item));
            terms.push(item);
        } else {
            queryTerms.searchTerms.map((item) => {
                store.dispatch(setSearchTerm(item));
                terms.push(item);
            });
        }
    }
    return terms;
};
